import styled, { useTheme } from 'styled-components'

import { Chip } from '@/@bothrs-ui/web/components/chip/Chip'
import { Flex } from '@/@bothrs-ui/web/components/layout'

export type FileTypeFilter = {
  id: string
  name: string
  unread?: number
  className?: string
}
type Props = {
  fileTypes: FileTypeFilter[]
  onSelected: (fileTypeId: string) => void
  selected: string
  className?: string
}
export const DocumentFilter = ({ fileTypes, onSelected, selected, className }: Props) => {
  const theme = useTheme()

  return (
    <Flex gap={theme.UI.Spacing.Space3} flexWrap='wrap' className={className}>
      {fileTypes.map((fileType) => {
        const isSelected = fileType.id === selected
        return (
          <button
            key={fileType.id}
            onClick={() => {
              onSelected(fileType.id)
            }}
            style={{ cursor: 'pointer' }}
          >
            <Chip type='Secondary' active={isSelected} larger>
              <Flex gap={theme.UI.Spacing.Space2} alignItems='center' style={{ position: 'relative' }}>
                {fileType.name}
                {fileType.unread && fileType.unread > 0 ? <StDot /> : null}
              </Flex>
            </Chip>
          </button>
        )
      })}
    </Flex>
  )
}

const StDot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.Colors.Status.Error};
`
